import { runInitTasks } from '@/core/services/initService';
import { useEffect, useRef, useState } from 'react';

function wait(ms: number): Promise<void> {
    return new Promise((resolve) => setTimeout(resolve, ms));
}

export function useSplash(minDurationMs: number = 3000) {
    const [isReady, setIsReady] = useState(false);
    const [isInitializing, setIsInitializing] = useState(true);
    const startedAt = useRef<number>(Date.now());

    useEffect(() => {
        let isMounted = true;

        const run = async () => {
            try {
                setIsInitializing(true);
                // Start both timers in parallel
                await Promise.all([
                    wait(minDurationMs),
                    runInitTasks().catch((e) => {
                        // Never throw – log and continue
                        return { total: 0, succeeded: 0, failed: 0, durationMs: 0, failures: [], degraded: false };
                    }),
                ]);
                if (!isMounted) return;
                setIsReady(true);
            } finally {
                if (isMounted) setIsInitializing(false);
            }
        };

        run();
        return () => {
            isMounted = false;
        };
    }, [minDurationMs]);

    return { isReady, isInitializing, startedAt: startedAt.current };
}


